module.exports = __webpack_public_path__ + "img/horizontal_6_4_6005.555719fc.png";